import Vue from 'vue'
import VueRouter from 'vue-router'
import NewVehicles from '../views/NewVehicles.vue'
import UsedVehicles from '../views/UsedVehicles.vue'
import AllVehicles from '../views/AllVehicles.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/vehicles/preowned/continental',
    name: 'used',
    component: UsedVehicles,
    props: true,
    meta: {
      title: 'Pre-Owned Vehicles | Continental Auto Group'
    }
  },
  {
    path: '/vehicles/new/continental',
    name: 'new',
    component: NewVehicles,
    props: true,
    meta: {
      title: 'New Vehicles | Continental Auto Group'
    }
  },
  {
    path: '/vehicles/:stockType/continental',
    name: 'all',
    component: AllVehicles,
    props: true,
    meta: {
      title: 'Vehicles | Continental Auto Group'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  linkExactActiveClass: 'active'
})

export default router
